angular.module('settingsModule')
    .component('staffRolesInternalUsers',
        {
            templateUrl: '/Scripts/app/settings/components/staff-roles/staff-roles-internal-users.template.html',
            });